// extracted by mini-css-extract-plugin
export default {"wrapper":"LinkShare_wrapper__E1y+D","share":"LinkShare_share__9bZbE","modal":"LinkShare_modal__AaUrI","link":"LinkShare_link__ErUSy"};